/**
 * Default Belgian VAT rate (%). Single source of truth — used by the web VAT
 * preference (`useVATInclPreference`) and by AI tools that need to convert
 * caller budgets between VAT-inclusive and VAT-exclusive.
 */
export const WEB_VAT_RATE_DEFAULT = 21;
